/*
 *    ____            _           _____
 *   / ___|    ___   | |   ___   |_   _|   ___    _ __    _   _
 *   \___ \   / _ \  | |  / _ \    | |    / _ \  | '_ \  | | | |
 *    ___) | | (_) | | | | (_) |   | |   | (_) | | | | | | |_| |
 *   |____/   \___/  |_|  \___/    |_|    \___/  |_| |_|  \__, |
 *  Created by Antonio Solo                               |___/
 *  Project & copyright: NSB.SU
 *
 */

import {CONSTANTS} from '@/constants';
import {functions} from '@/functions';
import miniToastr from "mini-toastr";

export const functions_guests = {

    data: function () {
        return {

        };
    },

    methods: {

        addGuest: function () {
            let tarif = null;
            if (this.voucher.m_only_number) {
                if (this.guests && (this.guests.length>0)) {
                    tarif = this.guests[0].t_obj_tariff_id;
                }
            }
            this.guests.push({
                surname: '',
                name_: '',
                patro: '',
                document_type: '',
                date_birthday_iso: null,
                age: 255,
                m_places_additionally: false,
                apply_social_discount: false,
                m_women: false,
                t_obj_tariff_id: tarif,
                summa: 0,
                discount_percent: 0,
                discount_value: 0,
                with_discount_value: 0,
                prepay_percent: 0,
                prepay_value: 0,
                comment_text: ''
            });
            this.voucher.count_places = this.guests.length;
        },

        // loadGuestsForVoucher: function (voucher_id, onSuccess=null, param=null) {
        //     if (!this.isGuestsLoaded() && voucher_id) {
        //         this.guests = [];
        //         this.httpPrepare();
        //         this.$http.get(this.apiurl('voucher/' + voucher_id + '/guests')).then(function (response) {
        //             response = this.httpSuccess(response);
        //             this.guests = response.payload;
        //             if (!this.guests.length) {
        //                 this.addGuest();
        //             }
        //             else {
        //                 for (let i=0; i<this.guests.length; i++) {
        //                     if ((this.guests[i].date_birthday_iso!==null) && this.guests[i].date_birthday_iso)
        //                         this.guests[i].date_birthday_iso = new Date(this.guests[i].date_birthday_iso.slice(0, 10));
        //                     else
        //                         this.guests[i].date_birthday_iso = null;
        //                     this.guests[i].m_women = !!this.guests[i].m_women;
        //                     this.guests[i].apply_social_discount = !!this.guests[i].apply_social_discount;
        //                     this.guests[i].m_places_additionally = !!this.guests[i].m_places_additionally;
        //                 }
        //                 this.executeFunction(onSuccess, param);
        //             }
        //         }, this.httpError)
        //     }
        //     return this;
        // },


        saveGuests: function (onSuccess=null, param=null) {
            console.log('saveGuests');
            this.httpPrepare();
            this.$http.post(this.apiurl('voucher/' + this.voucher_id + '/saveguests'), {guests:this.guests}).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param);
            }, this.httpError);
        },

        formatGuest: function(guest, age=false) {
            return formatGuest(guest, age);
        },

        getGuestById: function(guest_id) {
            for (let i=0; i<this.guests.length; i++) {
                if (this.guests[i].id == guest_id) {
                    return this.guests[i];
                }
            }
            return null;
        }

    },
};
